module.exports = __webpack_public_path__ + "static/media/deal-percentage.fc575ce6.png";